import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, HostListener, TemplateRef, inject } from '@angular/core';

import { DeviceService, WINDOW } from '@frontend/vanilla/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseDetailsTermsConditionsComponent } from '../../../base-details/base-details-terms-conditions/base-details-terms-conditions.component';
import { BaseDetailsContent } from '../../../base-details/base-details.model';
import { MultiRewardsListComponent } from '../../eds/multi-rewards/multi-rewards-list/multi-rewards-list.component';
import { OverviewContent } from '../models/overview-content';
import { ViewType } from '../models/view-type';
import { PromoOptInComponent } from '../opt-in/opt-in.component';
import { PromoRewardsComponent } from '../rewards/rewards.component';
import { TargetPromoState, commonContentMessages, optInDetails, rewardsContent, targetPromoContent } from '../store/target-promotion.selectors';

interface OverviewViewModel {
    overviewContent: OverviewContent;
    baseDetailsContent: BaseDetailsContent;
    clientContentMessages: { [key: string]: string };
    displayPlayNow: boolean;
}

@Component({
    selector: 'tp-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['../../../brat/brat-overview/brat-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LetDirective,
        NgClass,
        BaseDetailsTermsConditionsComponent,
        PromoOptInComponent,
        PromoRewardsComponent,
        MultiRewardsListComponent,
        NgTemplateOutlet,
    ],
})
export class OverviewComponent {
    @ContentChild('secondaryRewards', { static: true }) secondaryRewardsTpl: TemplateRef<any>;

    viewType: string = ViewType?.view;
    desktop: boolean = !this.deviceService.isMobile;
    rewardsContent$ = this.store?.select(rewardsContent);

    vm$: Observable<OverviewViewModel> = combineLatest([
        this.store.select(targetPromoContent),
        this.store.select(optInDetails),
        this.store.select(commonContentMessages),
    ]).pipe(
        map(([targetPromoContent, optInDetails, commonContentMessages]) => {
            return {
                overviewContent: targetPromoContent?.overviewContent,
                baseDetailsContent: targetPromoContent,
                clientContentMessages: commonContentMessages ?? {},
                displayPlayNow: optInDetails?.displayPlayNow && targetPromoContent?.promotionStatus?.toLowerCase() === 'started',
            };
        }),
    );
    readonly #window = inject(WINDOW);

    constructor(
        private store: Store<{ targetPromotionModuleData: TargetPromoState }>,
        private deviceService: DeviceService,
    ) {}

    @HostListener('window:resize', [])
    onResize() {
        this.desktop = this.#window.innerWidth > 600;
    }
}
